// extracted by mini-css-extract-plugin
export var copyableField = "_n9-4";
export var customerBadge = "_n9-0";
export var customerInfoTitle = "_n9-2";
export var details = "_n9-1";
export var dropdownContainer = "_n9-5";
export var dropdownImage = "_n9-6";
export var editAssigneeForm = "_n9-a";
export var editButton = "_n9-3";
export var email = "_n9-7";
export var hidden = "_n9-d";
export var input = "_n9-8";
export var saveButton = "_n9-b";
export var shopifyIcon = "_n9-c";
export var suggestionBadge = "_n9-e";
export var suggestionText = "_n9-f";
export var username = "_n9-9";